import { render } from "./IconBase.vue?vue&type=template&id=50db2a73&scoped=true"
import script from "./IconBase.vue?vue&type=script&lang=js"
export * from "./IconBase.vue?vue&type=script&lang=js"

import "./IconBase.vue?vue&type=style&index=0&id=50db2a73&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-50db2a73"

export default script